import React from 'react'

const FormCard = ({ title, renderTag, children, className }) => {
    return (
        <div className={`custom-shadow w-full h-fit bg-white rounded-2xl p-xl p-6 border ${className}`}>
            <div className="w-full flex-col md:flex-row flex items-start md:items-center justify-between mb-4">
                <h2 className="text-xl font-semibold w-full text-gray-800">{title}</h2>
                {renderTag &&
                    <div className="w-full flex justify-end">
                        {renderTag()}
                    </div>
                }
            </div>
            {children}
        </div>
    )
}

export default FormCard